<template>
		<div v-throttle="[shareButtonClick,5000,`click`]" style="margin-left: -385px;">
			<share network="facebook" :config="share_config" ></share>
		</div>
</template>

<script>
	export default {
		 directives: {
		    customShareButton: {
		      bind(el, binding, vnode) {
		        el.addEventListener('click', () => {
		          // 在这里执行分享按钮点击后的操作
		          console.log('分享按钮被点击了');
		        });
		      }
		    }
		  },
		name:'goShare',
		props:{
			zytitle:{
				type:String,
				default:''
			},
			imageSrc:{
				default:'',
				type:String,
				}
			
		},
		data() {
			return {
				share_config: {
					url: `${location.href}`, // 网址，默认使用 window.location.href
					source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
					title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
					description: "找外协", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
					image: "", // 图片, 默认取网页中第一个img标签
					sites: ["weibo", "wechat", "qzone", "qq"], // 启用的站点
					// disabled: ["google", "facebook", "twitter"], // 禁用的站点
					wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
					wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享。</p>",
				},
			}
		},
		created() {
			this.share_config.title = this.zytitle
			this.share_config.image = this.imageSrc
		},
		methods:{
			   shareButtonClick() {
			      // 在这里执行分享按钮点击后的操作
				  this.$emit('share')
			      // console.log('分享按钮被点击了');
			    }
		}
	}
</script>

<style>
</style>